import React from "react";
import {FooterSection} from "../components/Footer.jsx";
import {Link} from "react-router-dom";

const TermsPage = () => {
    return (
        <div className="min-h-screen bg-zinc-900 text-gray-100">
            {/* NavBar */}
            <nav className="sticky top-0 z-50 bg-[#1a1a1a] border-b border-[#FF4D00]/10 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo */}
                        <Link to="/" className="flex items-center space-x-3">
                            <div className="w-8 h-8">
                                <img
                                    src={require("../assets/helga_launcher_icon.png")}
                                    alt="Helga Logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <span
                                className="text-2xl font-bold bg-clip-text text-[#FF4D00]">
                                Helga Festival Companion
                             </span>
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <main className="py-12">
                <div className="max-w-4xl mx-auto px-4">
                    <div className="prose prose-invert max-w-none">
                        <div className="bg-white/5 p-8 rounded-2xl backdrop-blur-sm border border-[#FF4D00]/10">
                            <h2 className="text-2xl font-semibold mb-6 text-[#FF4D00]">
                                Impressum
                            </h2>
                            <p className="text-gray-300 mb-4">
                                apirious GmbH<br/>
                                Bad Nauheimer Straße 4<br/>
                                64289 Darmstadt<br/>
                                <br/>
                                Telefon: +49 (0)6151 8624000<br/>
                                E-Mail: contact@apirious.com<br/>

                                Managing Directors Michael Smorra and Arvid Lange<br/>
                                <br/>
                                Register Entry:<br/>
                                Registered in the commercial register.<br/>
                                Register Court: Darmstadt District Court<br/>
                                Registration Number: HRB 95232<br/>

                                VAT ID:<br/>
                                Value Added Tax Identification Number according to § 27a of the German Value Added Tax
                                Act: DE 305493282</p>
                            <h3 className="text-xl font-semibold mt-8 mb-4">Disclaimer - Legal Notice</h3>
                            <p className="text-gray-300 mb-4">§ 1 Limitation of Liability</p>
                            The contents of this website are created with the utmost care. However, the provider
                            does not guarantee the accuracy, completeness, or timeliness of the provided content.
                            The use of the content on the website is at the user's own risk. Articles marked with
                            the name of the respective author reflect the opinion of the author and not necessarily
                            that of the provider. By simply using the provider's website, no contractual
                            relationship between the user and the provider is established.
                            <br/><br/>
                            <p className="text-gray-300 mb-4">§ 2 External Links</p>
                            This website contains links to third-party websites ("external links"). These websites
                            are the responsibility of the respective operators. When the external links were first
                            established, the provider checked the foreign content for potential legal violations. At
                            that time, no violations were evident. The provider has no influence on the current and
                            future design or the content of the linked pages. The inclusion of external links does
                            not mean that the provider adopts the content behind the link. Continuous monitoring of
                            external links is not reasonable for the provider unless there are concrete indications
                            of legal violations. However, if the provider becomes aware of any legal violations,
                            such links will be immediately removed.
                            <br/><br/>
                            <p className="text-gray-300 mb-4">§ 3 Copyright and Related Rights</p>
                            Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und
                            Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht
                            zugelassene Verwertung
                            bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen
                            Rechteinhabers. Dies gilt
                            insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung,
                            Verarbeitung bzw.
                            Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen.
                            Inhalte und
                            Rechte Dritter sind dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung
                            oder Weitergabe
                            einzelner Inhalte oder kompletter Seiten ist nicht gestattet und strafbar. Lediglich die
                            Herstellung von
                            Kopien und Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist
                            erlaubt.
                            Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis
                            zulässig.
                            <br/><br/>
                            <p className="text-gray-300 mb-4">§ 4 Special Terms of Use</p>
                            If specific terms and conditions for certain uses of this website differ from the
                            aforementioned paragraphs, this will be explicitly stated at the relevant location. In
                            such cases, the special terms of use will apply.

                            Source: Legal notice created with Juraforum.


                        </div>
                    </div>
                </div>
            </main>
            <>
                <FooterSection/>
            </>
        </div>
    );
};

export default TermsPage;
